import type { ReactElement } from "react"
import TextAtm from "@onestore/hel/dist/components/atoms/TextAtm"
import ToggleWithLabelsAtm from "@onestore/hel/dist/components/atoms/ToggleWithLabelsAtm"
import WrapOrg from "@onestore/hel/dist/components/organisms/WrapOrg"
import { useTogglePriceType } from "~/hooks/useTogglePriceType"
import isEmpty from "~/lib/isEmpty"

type Props = {
  text?: string
}

const TogglePriceType = ({ text }: Props): ReactElement<Props> => {
  const toggleProps = useTogglePriceType()

  return (
    <WrapOrg gutterSpace={2} alignCenter="vertical">
      {!isEmpty(text) ? <TextAtm typography="nano1">{text}</TextAtm> : null}

      <ToggleWithLabelsAtm {...toggleProps} />
    </WrapOrg>
  )
}

export default TogglePriceType
